module.exports = __webpack_public_path__ + "img/stanford.f72e9527.png";